<template>
    <div class="admin-list">
        <div class="box-list">
            <center>
                <h3>Lista perfiles administrativos</h3>
                <table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Apellido</th>
                            <th>Tipo de documento</th>
                            <th>Documento</th>
                            <th>Balance</th>
                            <th>Celular</th>
                            <th>Ver perfil</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in list" :key="index">
                            <td>{{++index}}</td>
                            <td>{{item.stagename}}</td>
                            <td>{{item.lastname}}</td>
                            <td>{{item.document_type}}</td>
                            <td>{{item.document}}</td>
                            <td><select name="" id="" v-model="item.status" @change="changeStatusAdmin(item.id, item.status)">
                                <option value="approved">Aprobada</option>
                                <option value="block">Retirada</option>
                            </select></td>
                            <td>{{item.phone}}</td>
                            <td><button @click="$router.push('/admin/' + item.id + '/profile-admin')">Ver perfil</button></td>
                        </tr>
                    </tbody>
                </table>
            </center>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Price from '@/utils/ConvertPriceNumber'

export default {
    name: 'admin-list',
    data() {
        return {
            list: []
        }
    },
    methods: {
        changeStatusAdmin(id, status) {
            API.changeStatusAdmin(id, status)
                .then((res) => {
                    this.list = []
                    this.getAdminList()
                })
        },
        priceFormat: function(item) {
            return Price(item)
        },
        getAdminList() {
            API.getAdminList()
                .then((res) => {
                    this.list = res
                })
        }
    },
    mounted() {
        this.getAdminList()
    }
}
</script>

<style scoped>
.admin-list {
    background-color: #cdcdcd;
    height: 88vh;
    padding: 20px;
}
.admin-list > .box-list {
    background: #585858;
    width: 100%;
    padding: 20px;
    height: 100%;
    border-radius: 20px;
    border-style: outset;
}
.admin-list > .box-list > center {
    padding: 30px;
    overflow-y: auto;
    height: 100%;
}
.admin-list > .box-list > center > table {
    margin-top: 30px;
    border-radius: 20px;
}
.admin-list > .box-list > center > table > thead > tr {
    text-align: center;
    color: #fff;
    font-weight: bold;
    background-color: #3a88b5;
}
.admin-list > .box-list > center > table > thead > tr > th {
    padding: 30px;
    border-style: double;
}
.admin-list > .box-list > center > table > tbody > tr {
    text-align: center;
    color: #fff;
    font-weight: bold;
}
.admin-list > .box-list > center > table > tbody > tr > td {
    padding: 10px;
    border-style: double;
}
.admin-list > .box-list > center > table > tbody > tr > td > button {
   background-color: #e0b059;
    color: #fff;
    min-width: 50px;
    height: auto;
    border-radius: 30px;
    width: 200px;
    padding: 10px;
}
.admin-list > .box-list > center > h3 {
    color:#fff
}
</style>



// WEBPACK FOOTER //
// src/components/AdminsProfiles/AdminList.vue